import { render, staticRenderFns } from "./areaAdminPageGroups.vue?vue&type=template&id=493501a6&scoped=true"
import script from "./areaAdminPageGroups.vue?vue&type=script&lang=js"
export * from "./areaAdminPageGroups.vue?vue&type=script&lang=js"
import style0 from "./areaAdminPageGroups.vue?vue&type=style&index=0&id=493501a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493501a6",
  null
  
)

export default component.exports